import { Component, Inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { KeyValue } from './models/key-value.model';

@Component({
    selector: 'nova-drop-down-dialog',
    templateUrl: './drop-down-dialog.component.html',
    standalone: true,
    imports: [
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        FormsModule,
        MatDialogModule
    ]
})
export class DropDownDialogComponent {
    @Input() title: string;
    @Input() selection: KeyValue<number, string>;
    @Input() selectTitle: string;
    @Input() selectItems: KeyValue<number, string>[];

    constructor(
        private readonly dialogRef: MatDialogRef<DropDownDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            selectTitle: any;
            selection: KeyValue<number, string>;
            selectItems: KeyValue<number, string>[];
        }
    ) {
        this.selection = data.selection;
        this.selectItems = data.selectItems;
        this.selectTitle = data.selectTitle;
        this.title = data.title;
    }

    close(result: boolean) {
        this.dialogRef.close(result ? this.selection : null);
    }
}
